import { Options } from 'vue-class-component';
import DeviceSettingsComponent from '../DeviceSettingsComponent';

@Options({
  name: 'LocksActuatorSettings',
})
export default class LocksActuatorSettings extends DeviceSettingsComponent {
  get settings() {
    return this.defaultSettings.lockActuatorSettings;
  }
}
